export default __webpack_public_path__ + "navigation-examples-electronic-horizon-thumbnail-960-235467a09f50968848f0185d82702c1f.png";